"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _source = require("../../../actions/source");
function toggledPresenterLive(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var attendeeId = _ref2.attendeeId;
  var _getState = getState(),
    broadcastSources = _getState.broadcastSources;
  var source = broadcastSources.sources.find(function (s) {
    return s.value === attendeeId;
  });
  if (!!source) {
    dispatch((0, _source.takePresenterLive)(source));
  }
}
var _default = exports["default"] = toggledPresenterLive;